import { useEffect, useState } from 'react';

function format(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = seconds % 60;
  const pad = (value: number) => String(value).padStart(2, '0');
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(rest)}` : `${minutes}:${pad(rest)}`;
}

/**
 * Time on the call, as a clock.
 *
 * Derived from a timestamp rather than counted up, so a tab that gets
 * backgrounded — and has its timers throttled to once a minute — still shows
 * the right duration when the candidate comes back to it.
 */
export function useElapsed(): string {
  const [startedAt] = useState(() => Date.now());
  const [label, setLabel] = useState(() => format(0));

  useEffect(() => {
    const tick = () => setLabel(format((Date.now() - startedAt) / 1000));
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  return label;
}
